import TableRow from "./table-row.component";

export default TableRow;
